import { Component, Renderer2, Inject, OnInit, OnDestroy } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { RelevantNewsarticleComponent } from '../relevant-newsarticle/relevant-newsarticle.component';

interface ArticlePost {
  id: number;
  title: string;
  image: string;
  slug?: string;
}
@Component({
  selector: 'app-pioneering-ai',
  imports: [CommonModule, RelevantNewsarticleComponent],
  standalone: true,
  templateUrl: './pioneering-ai.component.html',
  styleUrl: './pioneering-ai.component.scss'
})
export class PioneeringAiComponent implements OnInit, OnDestroy {
  private jsonLdScript: any;
  constructor(
    private renderer: Renderer2,
    @Inject(DOCUMENT) private _document: Document
  ) { }

  ngOnInit(): void {
    this.injectSchemaMarkup();
  }

  ngOnDestroy(): void {
    this.removeSchemaMarkup();
  }
injectSchemaMarkup(): void {
    const pioneeringAiSchema = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id": "https://www.kalpitatechnologies.com/kalpita-press-release/pioneering-ai",
          "url": "https://www.kalpitatechnologies.com/kalpita-press-release/pioneering-ai",
          "name": "Pioneering AI at Kalpita — Kalpita Technologies",
          "description": "Kalpita Technologies leads AI-powered software development by deeply integrating RAG, NLP, and predictive analytics into enterprise solutions.",
          "speakable": {
            "@type": "SpeakableSpecification",
            "cssSelector": [
              ".softwaredev-heading",
              ".takeaways-section .takeaway-item p",
              ".section-title"
            ]
          },
          "significantLink": [
            "https://www.issuewire.com/kalpita-technologies-leads-the-charge-in-ai-powered-software-with-rag-nlp-and-advanced-predictive-analytics-1830260429392606"
          ],
          "datePublished": "2025-04-24",
          "dateModified": "2025-04-24",
          "isPartOf": { "@type": "WebSite", "@id": "https://www.kalpitatechnologies.com/#website" }
        },
        {
          "@type": "BreadcrumbList",
          "@id": "https://www.kalpitatechnologies.com/kalpita-press-release/pioneering-ai#breadcrumb",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://www.kalpitatechnologies.com/" },
            { "@type": "ListItem", "position": 2, "name": "News", "item": "https://www.kalpitatechnologies.com/kalpita-press-release/inthenews" },
            { "@type": "ListItem", "position": 3, "name": "Pioneering AI", "item": "https://www.kalpitatechnologies.com/kalpita-press-release/pioneering-ai" }
          ]
        },
        {
          "@type": "TechArticle",
          "headline": "Kalpita Technologies Leads the Charge in AI-Powered Software with RAG, NLP, and Advanced Predictive Analytics",
          "alternativeHeadline": "How Kalpita Embeds AI into Every Layer of Enterprise Software Development",
          "articleBody": "Kalpita Technologies has taken a bold step into the future by launching a comprehensive AI-driven framework that is reshaping enterprise solutions...",
          "author": { "@type": "Organization", "name": "IssueWire" },
          "publisher": {
            "@type": "Organization",
            "name": "Kalpita Technologies",
            "logo": { "@type": "ImageObject", "url": "https://www.kalpitatechnologies.com/assets/common/black-logo.png" }
          },
          "datePublished": "2025-04-24"
        },
        {
          "@type": "HowTo",
          "name": "How to Build an AI-First Enterprise Like Kalpita Technologies",
          "step": [
            { "@type": "HowToStep", "name": "Adopt AI-First Strategy", "text": "Embed AI into every aspect of operations rather than layering it on top." },
            { "@type": "HowToStep", "name": "Integrate Advanced Capabilities", "text": "Deploy RAG for contextual intelligence and NLP for language understanding." },
            { "@type": "HowToStep", "name": "Automate Workflows", "text": "Enable AI-powered software systems within core Applications like CRM and ERP." },
            { "@type": "HowToStep", "name": "Foster AI Literacy", "text": "Ensure workforce readiness with training across HR, Finance, and Marketing." },
            { "@type": "HowToStep", "name": "Modernize the SDLC", "text": "Use AI-assisted coding and testing tools to accelerate project delivery." }
          ]
        },
        {
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "How does Kalpita Technologies use AI in software development?",
              "acceptedAnswer": { "@type": "Answer", "text": "Kalpita integrates AI-assisted coding, automated test reliability checks, and predictive analytics for project planning." }
            },
            {
              "@type": "Question",
              "name": "What is Agentic AI at Kalpita?",
              "acceptedAnswer": { "@type": "Answer", "text": "Agentic AI refers to software systems integrated into ERP/HR processes that autonomously respond to routine inquiries." }
            }
          ]
        },
        {
          "@type": "Organization",
          "@id": "https://www.kalpitatechnologies.com/#organization",
          "name": "Kalpita Technologies",
          "url": "https://www.kalpitatechnologies.com/",
          "logo": { "@type": "ImageObject", "url": "https://www.kalpitatechnologies.com/assets/common/black-logo.png" }
        },
        {
          "@type": "LocalBusiness",
          "@id": "https://www.kalpitatechnologies.com/#localbusiness",
          "name": "Kalpita Technologies — Austin Office",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Suite #300, 3rd Floor, Building 2, 1250 South Capital of Texas Highway",
            "addressLocality": "Austin",
            "addressRegion": "TX",
            "postalCode": "78746",
            "addressCountry": "US"
          },
          "telephone": "+1-512-240-2484",
          "url": "https://www.kalpitatechnologies.com/"
        }
      ]
    };

    this.jsonLdScript = this.renderer.createElement('script');
    this.jsonLdScript.type = 'application/ld+json';
    this.jsonLdScript.text = JSON.stringify(pioneeringAiSchema);
    this.renderer.appendChild(this._document.head, this.jsonLdScript);
  }
  removeSchemaMarkup(): void {
    if (this.jsonLdScript) {
      this.renderer.removeChild(this._document.head, this.jsonLdScript);
      this.jsonLdScript = null;
    }
  }
  articles: ArticlePost[] = [
    {
      id: 1,
      title: 'Lorem ipsum dolor sit amet, consectetur elit',
      image: '../../../../assets/resources/whitepaper/it-trends/art-card-one.webp'
    },
    {
      id: 2,
      title: 'Lorem ipsum dolor sit amet, consectetur elit',
      image: '../../../../assets/resources/whitepaper/it-trends/art-card-two.webp'
    },
    {
      id: 3,
      title: 'Lorem ipsum dolor sit amet, consectetur elit',
      image: '../../../../assets/resources/whitepaper/it-trends/art-card-three.webp'
    },
    {
      id: 4,
      title: 'Lorem ipsum dolor sit amet, consectetur elit',
      image: '../../../../assets/resources/whitepaper/it-trends/art-card-four.webp'
    },
    {
      id: 5,
      title: 'Lorem ipsum dolor sit amet, consectetur elit',
      image: '../../../../assets/resources/whitepaper/it-trends/art-card-five.webp'
    },
    {
      id: 6,
      title: 'Lorem ipsum dolor sit amet, consectetur elit',
      image: '../../../../assets/resources/whitepaper/it-trends/art-card-six.webp'
    },
    {
      id: 7,
      title: 'Lorem ipsum dolor sit amet, consectetur elit',
      image: '../../../../assets/resources/whitepaper/it-trends/art-card-seven.webp'
    },
    {
      id: 8,
      title: 'Lorem ipsum dolor sit amet, consectetur elit',
      image: '../../../../assets/resources/whitepaper/it-trends/art-card-eight.webp'
    }
  ];
  onArticleClick(article: ArticlePost): void {
    console.log('Article clicked:', article);
    // Handle navigation to article detail page
  }

  trackByArticle(index: number, article: ArticlePost): number {
    return article.id;
  }
}
